export const GET_IS_OLD = 'GET_IS_OLD'
